import React, { useEffect, useState } from "react";
import { collection, query, orderBy, limit, onSnapshot, updateDoc, doc } from "firebase/firestore";
import { db, auth } from "../firebaseConfig";
import "../styles/AlertsDropdown.css";

const AlertsDropdown = () => {
  const [alerts, setAlerts] = useState([]);
  const [visible, setVisible] = useState(false);
  const [unseenCount, setUnseenCount] = useState(0);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;

    const q = query(
      collection(db, "alerts"),
      orderBy("createdAt", "desc"),
      limit(20)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const all = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      const userAlerts = all.filter(
        (alert) =>
          alert.userId === user.uid ||
          alert.tier === "premium" ||
          alert.tier === "standard"
      );

      setAlerts(userAlerts);
      setUnseenCount(userAlerts.filter((a) => !a.seen).length);
    });

    return () => unsubscribe();
  }, []);

  const toggleDropdown = async () => {
    setVisible(!visible);
    if (!visible) {
      // Mark all alerts as seen
      const user = auth.currentUser;
      const unseenAlerts = alerts.filter((a) => !a.seen && a.userId === user.uid);
      for (const alert of unseenAlerts) {
        try {
          await updateDoc(doc(db, "alerts", alert.id), { seen: true });
        } catch (error) {
          console.error("Error marking alert as seen:", error);
        }
      }
      setUnseenCount(0);
    }
  };

  return (
    <div className="alerts-wrapper">
      <button className="alerts-btn" onClick={toggleDropdown}>
        🔔
        {unseenCount > 0 && <span className="badge">{unseenCount}</span>}
      </button>

      {visible && (
        <div className="alerts-dropdown">
          <h4>Recent Alerts</h4>
          {alerts.length === 0 ? (
            <p className="no-alerts">No alerts</p>
          ) : (
            <ul>
              {alerts.map((a) => (
                <li key={a.id} className={`alert-${a.severity}`}>
                  <span className="alert-icon">
                    {a.severity === "critical" ? "🚨" : "⚠️"}
                  </span>
                  <div>
                    <strong>{a.type}</strong> – {a.plateNumber}: {a.message}
                    <br />
                    <small>{new Date(a.createdAt?.toDate()).toLocaleString()}</small>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default AlertsDropdown;